export default {
    ca: {
        menu: {
            home: 'Inici',
            gallery: 'Galeria',
            blog: 'Blog',
            videos: 'Vídeos',
            faq: 'FAQ',
            contact: 'Contactar',
            language: 'Idioma',
            login: 'Fes el teu mapa',
            logout: 'Tancar sessió',
            profile: 'Els meus mapes i perfil',
        },
    },
    es: {
        menu: {
            home: 'Inicio',
            gallery: 'Galería',
            blog: 'Blog',
            videos: 'Vídeos',
            faq: 'FAQ',
            contact: 'Contactar',
            language: 'Idioma',
            login: 'Haz tu mapa',
            logout: 'Cerrar sesión',
            profile: 'Mis mapas y perfil',
        },
    },
    en: {
        menu: {
            home: 'Home',
            gallery: 'Gallery',
            blog: 'Blog',
            videos: 'Videos',
            faq: 'FAQ',
            contact: 'Contact',
            language: 'Language',
            login: 'Make your map',
            logout: 'Log out',
            profile: 'My maps and profile',
        },
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/header/header-translations.js